// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Banner_bannerContainer__lniUG","bannerComponent":"Banner_bannerComponent__cHi21"};